module.exports = __webpack_public_path__ + "assets/Zeta.a63bdeeaf72cdd74fd00012f5de002b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Zeta.png
// module id = 803
// module chunks = 0